import { pushSucessNotification } from "@/src/lib/SmartDB/Commons/pushNotification";
import { WEBSITE_TITLE } from "@/src/utils/constants";


export const useCopyButton = () => {
    //--------------------------------------
    const handleBtnCopy = async (content: string) => {
        navigator.clipboard.writeText(content)
        pushSucessNotification(WEBSITE_TITLE, `Copied to clipboard!`, false);

    };
    //--------------------------------------
    return {
        handleBtnCopy,
    };
    //--------------------------------------
};
